var path = 'public/app/features/plugins/partials/ds_dashboards.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\" ng-if=ctrl.datasourceMeta>\n\n\t<dashboard-import-list plugin=ctrl.datasourceMeta datasource=ctrl.current></dashboard-import-list>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/features/plugins/partials/ds_dashboards.html
// module id = 1087
// module chunks = 3